<template>
<div class="pagewide users mtpage">

	<topheader back="/panel">
		<template v-slot:info>
			<span>{{$t('labels.users')}}</span>
		</template>
		<template v-slot:right>
			
		</template>

	</topheader>

	<maincontent>
		<template v-slot:content>
            <users />
		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	

</style>

<script>


export default {
	name: 'panel_users_page',
	components: {
		users : () => import("@/components/modules/panel/users/index.vue")
	},

	data : function(){
		return { 
			searchEnabled : false
		}
	},

	computed: {

	},

	methods: {
		
	},

	mounted() {

	}
}
</script>
